import { OneSchemaImporterClass } from '@oneschema/importer'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import { oneschemaConfig } from '@/api/oneschema/config'

export default defineNuxtPlugin((app) => {
  const { arEnvironment } = useRuntimeConfig().public
  const importer = new OneSchemaImporterClass(oneschemaConfig(arEnvironment))

  app.provide('osImporter', importer)
})
